// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileSideMenu":"jc_a bie_sv bie_tr bie_wq"};